<asax-frequency-view-frequency-view-chart-filters-container 
                                          (outHeight)="heightFrequencyChartFiltersContainer=$event">
</asax-frequency-view-frequency-view-chart-filters-container>
<div class="position-relative">
    <asax-frequency-view-frequency-view-chart [height]="height - heightFrequencyChartFiltersContainer"
                                            [width]="width"
                                            [extremes]="extremes | async"
                                            [splats]="splats | async"
                                            [footprintHovered]="footprintHovered | async"
                                            [frequenciesIntervalsRowHovered]="frequenciesIntervalsRowHovered | async"
                                            [frequency]="frequency | async"
                                            [selectedFrequencies]="selectedFrequencies | async"
                                            (outFrequencyChartMouseMove)="onOutFrequencyChartMouseMove($event)"
                                            (outSplatHovered)="onOutSplatHovered($event)"
                                            (outChartWidth)="onOutChartWidth($event)"
                                            (outExtremes)="onOutExtremes($event)"
                                            >
    </asax-frequency-view-frequency-view-chart>
    <asax-frequency-view-frequency-view-chart-reset-boundaries-button>
    </asax-frequency-view-frequency-view-chart-reset-boundaries-button>
</div>
<asax-frequency-view-frequency-view-chart-popover-container></asax-frequency-view-frequency-view-chart-popover-container>
